// extracted by mini-css-extract-plugin
export var burger = "NavigationBrand-module--burger--b0c99";
export var localeContainer = "NavigationBrand-module--locale-container--3c26a";
export var localePlaceholder = "NavigationBrand-module--locale-placeholder--727c2";
export var logo = "NavigationBrand-module--logo--a752c";
export var navbarBrand = "NavigationBrand-module--navbar-brand--30a8c";
export var root = "NavigationBrand-module--root--7c76f";
export var telephoneText = "NavigationBrand-module--telephoneText--a7f17";